// extracted by mini-css-extract-plugin
module.exports = {"main-component":"unlockIcon_main-component__P0Noa"};